import { useMemo } from 'react';
import { Key, Home } from 'lucide-react';

export interface NavigationItem {
  name: string;
  href: string;
  icon: React.ComponentType<any>;
  permission?: string;
  feature?: string;
  limit_visibility?: boolean;
}

const allNavigation: NavigationItem[] = [
  {
    name: 'Overview',
    href: '/overview',
    icon: Home,
  },
  {
    name: 'API Keys',
    href: '/api-keys',
    icon: Key,
    permission: 'read:api_keys',
  },
];

export function useNavigation(): NavigationItem[] {
  return useMemo(() => allNavigation, []);
}
